export default __webpack_public_path__ + "static/media/8.5b6ec445.jpg";